<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="800" persistent> 
  
        <v-card>
          <v-card-title class="text-h5 orange darken-3 white--text">
            Enviar Persona a Oracle NetSuite
          </v-card-title>
  
          <v-card-text class="px-2 pt-4">  
            <v-row>
                <v-col cols="12" sm="4"> <v-text-field v-model.trim="estudiante.nombres" hide-details dense outlined :readonly="!editar_datos" label="Nombres:" /> </v-col>
                <v-col cols="12" sm="4"> <v-text-field v-model.trim="estudiante.pri_apellido" hide-details dense outlined :readonly="!editar_datos" label="Apellido 1:" /> </v-col>
                <v-col cols="12" sm="4"> <v-text-field v-model.trim="estudiante.seg_apellido" hide-details dense outlined :readonly="!editar_datos" label="Apellido 2:" /> </v-col>
                <v-col cols="12" sm="5"> <v-text-field v-model.trim="estudiante.num_doc" hide-details dense outlined :readonly="!editar_datos" label="Documento:" /> </v-col>
                <v-col cols="12" sm="7"> <v-text-field v-model.trim="estudiante.email" hide-details dense outlined :readonly="!editar_datos" label="Correo:" /> </v-col>
                 
                <v-col cols="12" sm="6">
                  <v-radio-group v-model="estudiante.sexo" row :readonly="!editar_datos" >
                    <v-radio label="Masculino" value="M"></v-radio>
                    <v-radio label="Femenino" value="F"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="3"> <v-text-field v-model.trim="estudiante.telefono1" hide-details dense outlined :readonly="!editar_datos" label="Telefono 1:" /> </v-col>
                <v-col cols="12" sm="3"> <v-text-field v-model.trim="estudiante.telefono2" hide-details dense outlined :readonly="!editar_datos" label="Telefono 2:" /> </v-col>
                <v-col cols="12" sm="12"> <v-text-field v-model.trim="estudiante.domicilio" hide-details dense outlined :readonly="!editar_datos" label="Domicilio:" /> </v-col>
                <v-col cols="12" sm="4"> <v-text-field v-model.trim="estudiante.xfecha_nac" type="date" hide-details dense outlined :readonly="!editar_datos" label="Fecha Nacimiento:" /> </v-col>
            </v-row>
            <p v-if="personita && personita.cliente_netsuite_id" class="text-center my-0 purple--text"> Esta persona ya cuenta con cliente netsuite id({{ personita.cliente_netsuite_id }}), no puede editar los datos  </p>
          </v-card-text>
  
          <v-divider></v-divider>
          <v-progress-linear v-if="loading || verificando_is_netsuite" indeterminate color="green" />
          <p class="my-0 text-center red--text"> {{ msg }} </p>
  
          <v-card-actions>
            <v-spacer></v-spacer> 
            <v-btn :disabled="loading || verificando_is_netsuite" color="green" outlined @click="guardar()"> Registrar </v-btn>
            <v-btn :disabled="loading" color="red" outlined @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios'

// import xaxios from '@/xaxios';
export default {
  data () {
    return {
      dialog: false,
      loading: false,
      verificando_is_netsuite: false,
      editar_datos: false,
      msg:'',
      plan: {},
      personita:{},
      estudiante: {},
      customdata: {},
    }
  },
  methods:{ 
    openInsNet(estudiante, customdata={},verificar=false){
      // window.console.log('>>>>><<<<<', estudiante, customdata); 

      this.msg = '';
      this.personita = {};
      let obj = JSON.parse(JSON.stringify(estudiante));
      if(obj.fecha_nacimiento){
        let fs = obj.fecha_nacimiento.split("/");
        obj.xfecha_nac = `${fs[2]}-${fs[1]}-${fs[0]}`;
      }else{
        obj.xfecha_nac = obj.fecha_nac;
      }
      this.estudiante = obj;
      this.dialog = true;
      this.customdata = customdata;
      this.editar_datos = true;
      if( verificar ) {
        this.verrificarHecho(obj);
      }
    },
    async verrificarHecho(estudiante){
      this.editar_datos = false;
      this.verificando_is_netsuite = true;
      const url2 = `${process.env.VUE_APP_API_REST}/esam/persona/id/${estudiante.id}`;
      let res2 = await xaxios.get(url2).then(({data})=>data).catch(e=>e);
      // window.console.log('res2',res2);
      this.personita = res2.persona;
      this.editar_datos = res2.persona.cliente_netsuite_id == undefined;
      this.verificando_is_netsuite = false;
    },
    async venderAlma(){
      let message = {
        title: 'Bajo su responsabilidad:',
        body: '<br> <b>NOTA:</b> Recuerde que estos datos se mandan a netsuite, una ves guardado no se puede editar',
      };
      let options = {
        html: true,
        okText: 'Proceder',
        cancelText: 'Cancelar',
        reverse: true,
        type: 'soft',
        verification: ''+this.estudiante.num_doc,
        verificationHelp: 'Para confirmar ingrese nuevamente el carnet del estudiante.',
        loader: true,
      };
      let r = await this.$dialog.confirm(message, options).then(d=>d).catch(e=>e);
      return r;
    },
    tieneCaracteresespeciales(cadena) {
      const regex = /[ÁÉÍÓÚÑ áéíóúñ]/;
      return regex.test(cadena)
    },
    async guardar(){
      let txt = '';
      let s1 = (this.estudiante.telefono1+'').length;
      let s2 = (this.estudiante.telefono2+'').length;
      if( s1 > 0 && s1 < 8 ) txt = 'el telefono1 debe ser mayor o igual a 8 digitos';
      if( s2 > 0 && s2 < 8 ) txt = 'el telefono2 debe ser mayor o igual a 8 digitos';
      if(txt) {
        this.$root.$notify.show(txt, {color:'red',x: 'right',});
        return;
      } 

      const especiales = this.tieneCaracteresespeciales(this.estudiante.email);
      if(especiales){
        this.$root.$notify.show('el correo no debe contener caracteres mayusculas ni tildes ni la letra ñ', { color: 'red' });
        return;
      }

      if(!this.estudiante.profesiones) {
        this.$root.$notify.show("El estudiante no tiene profesion", {color:'red',x: 'right',});
        this.estudiante.profesiones = [];
        return;
      }
      this.loading = true;
      this.msg = '';
      const profs = this.estudiante.profesiones.map(item => item.id);
      let input = {
        id: this.estudiante.id,
        num_doc: this.estudiante.num_doc,
        nombres: this.estudiante.nombres,
        email: this.estudiante.email,
        sexo: this.estudiante.sexo,
        tipo: "E",
        diestro: true,
        profesiones: profs,

        pri_apellido: this.estudiante.pri_apellido,
        seg_apellido: this.estudiante.seg_apellido,
        domicilio: this.estudiante.domicilio,
        telefono1: this.estudiante.telefono1,
        telefono2: this.estudiante.telefono2,
        fecha_nac: this.estudiante.xfecha_nac
      }
      if(!input.telefono2) delete input.telefono2;

      // let x = 2;
      // window.console.log("dddd:", input);
      // if(x>1) return;

      if( this.personita && this.personita.cliente_netsuite_id ){
        await this.savenetsuite(input);
        return;
      }

      let r = await this.venderAlma();
      if(r) r.close(); 
      else {
        this.loading = false;
        return;
      }

      // window.console.log(this.estudiante, input);
      let sql = gql`mutation updatePersona($input:PersonaUpdateInput!){ updatePersona(input:$input){ok,errors{message}} }`;
      let res = await this.$apollo.mutate({mutation:sql, variables:{input:input}}).then(d=>d).catch(e=>e)
      if( res.data && res.data.updatePersona ){
        await this.savenetsuite(input);
      }else{ 
        if(!res.graphQLErrors[0]) {
          this.msg = res.message;
          this.loading = false;
          return;
        }
        let text = res.graphQLErrors[0].message.message.map(e=>e.error[0]);
        this.msg = text[0]
        this.loading = false;
      }
      
    },

    async savenetsuite(input){ 
      window.console.log('customdata..',this.customdata);
      let data = {
        "cliente_id": input.id,
        "sede_id": this.customdata.sede.id,
        "subsidiaria_id": this.customdata.sede.subsidiaria_id,
        ubicacion: this.customdata.sede.ubicacion,
        ubicacion_id: this.customdata.sede.ubicacion_id, 
      }
      const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cliente/netsuite`;
      let res = await xaxios.post(url, data).then(({data})=>data).catch(e=>e)
      window.console.log('.....', res);
      if(res && res.data ){
        this.loading = false;
        this.dialog = false;
        let s = res.data.result;
        this.$root.$notify.show(s, {color:'success',x: 'right',});
        this.$emit('success',s)
      }else{
        window.console.log('><>>>,', res.response);
        this.loading = false;
        let s = res.response? res.response.data.data :  res;
        this.$root.$notify.show(s, {color:'red',x: 'right',});
      }
    },
  }
}
</script>